import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {Alert} from 'reactstrap';
import classNames from 'classnames';
import React, { useState } from 'react'
import NumberFormat from 'react-number-format';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table, UncontrolledDropdown } from 'reactstrap';
import ButtonIconTooltip from '../../common/ButtonIconTooltip';
import Flex from '../../common/Flex';
import PageHeader from '../../common/PageHeader';
import { If, isIterableArray } from '../../UI/preloading/PreloadState';
import PayMethodAddModal from './components/PayMethodAddModal';
import useSWRFetchPagination from '../../../helpers/hooks/useSWRFetchPagination';
import { fetchPublicBanks, removeBankRoot } from '../../../helpers/api/banks';
import { SUCCESS_RESPONSE } from '../../../helpers/codeResponses/codes';
import { Toast } from '../../UI/toast/Toast';
import handleErrorMessage from '../../../helpers/errors/handleErrorMessage';
import FullPagination from '../../common/pagination/FullPagination';
import { PreloadState, Or, Message } from '../../UI/preloading/PreloadState';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const PayMethods = () => {

    const [isOpen, setIsOpen] = useState(false);
    const [collapseOne, collapseOneOpen] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [selectedMethod, setSelectedMethod] = useState(null);
    const [selected, setSelected] = useState(null);
    console.log(selected);
    // eslint-disable-next-line no-unused-vars
    const [params, setParams] = useState({ search: '' })
    const {
        data,
        error,
        isLoading,
        mutate,
        meta,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(fetchPublicBanks, params);

    const handleModalConfirm = () => (
        <Modal isOpen={collapseOne} centered data-testid="modal">
            <ModalHeader>Confirmación</ModalHeader>
            <ModalBody>
                <p className='mb-0'>¿Está seguro de eliminar este método?</p>
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => collapseOneOpen(false)}>
                    Cancelar
                </Button>
                <Button
                    data-testid="submit-button"
                    color="primary"
                    type='submit'
                    onClick={() => {
                        removeBank(selectedMethod);
                    }}
                >Sí, eliminar</Button>
            </ModalFooter>
        </Modal>
    )

    const removeBank = (id) => {
        removeBankRoot(id)
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({
                        type: 'success',
                        title: 'Método de pago eliminado exitosamente.'
                    })
                    mutate();
                    collapseOneOpen(false);
                }
            })
            .catch(err => handleErrorMessage(err));
    }

    return <>
        <PageHeader title='Métodos de pago' titleTag="h2" className="mb-3" col={{ lg: 9 }} description="Gestiona tus métodos de pago." />
        <Card>
            <CardHeader className='bg-light'>
                <Row>
                    <Col tag={Flex} align='center' justify='between'>
                        <h5>Métodos de pago</h5>
                        <ButtonIconTooltip color='falcon-default' size='md' icon={faPlus} onClick={() => setIsOpen(true)} id='paymethodadd' text='Añadir método de pago' placement='left'>Añadir método de pago</ButtonIconTooltip>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody className={classNames('fs--1', { 'p-0': isIterableArray(data) })}>
                <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                    <Table value={true} responsive className='mb-0'>
                        <thead>
                            <tr>
                                <th className='align-middle' style={{ width: '15%' }}>Método de pago</th>
                                <th className='align-middle text-center' style={{ width: '40%' }}>Banco</th>
                                <th className='align-middle text-center'>Titular</th>
                                <th className='align-middle text-center'>Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map(({ id, bank_id = null, name, owner_name, owner_dni, email, phoneNumber, method = 'bank', account_number }, index) => (
                                <tr key={id}>
                                    <td className='align-middle' style={{ width: '15%' }}><b>{method === 'bank' ? 'Transferencia bancaria' : method === 'mobile' ? 'Pago móvil' : method === 'zelle' && 'Zelle'}</b></td>
                                    <td className='align-middle text-center' style={{ width: '40%' }}>
                                        <If cond={method}>
                                            <Flex value={'bank'} column align='center' justify='center'>
                                                <p className='mb-0' >{name}</p>
                                                <p className='mb-0'><b><NumberFormat displayType='text' format='#### #### #### #### ####' value={account_number} /></b></p>
                                            </Flex>
                                            <Flex value={'mobile'} column align='center' justify='center'>
                                                <p className='mb-0' >{name}</p>
                                                <p className='mb-0'><b><NumberFormat displayType='text' format='+58 (###) ### ####' value={phoneNumber} /></b></p>
                                            </Flex>
                                            <Flex value={'zelle'} column align='center' justify='center'>
                                                <p className='mb-0' >{name}</p>
                                                <p className='mb-0'><b>{email}</b></p>
                                            </Flex>
                                        </If>
                                    </td>
                                    <td className='align-middle text-center'>
                                        <p className='mb-0'>{owner_name}</p>
                                        {(method === 'mobile' || method === 'bank') && <p className='mb-0'><b><NumberFormat prefix={owner_dni?.charAt(0)} thousandSeparator value={parseFloat(owner_dni.substring(1, 40))} displayType='text' /></b></p>}
                                    </td>
                                    <td className='align-middle text-center'>
                                        <UncontrolledDropdown direction="left">
                                            <DropdownToggle color="falcon-default" size="sm">
                                                <FontAwesomeIcon icon="ellipsis-h" />
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                <DropdownItem onClick={() => {
                                                    setSelected({ ...data[index], method });
                                                    setIsOpen(true);
                                                }} >Editar</DropdownItem>
                                                <DropdownItem className='text-danger' onClick={() => {
                                                    if (method === 'bank') {
                                                        setSelectedMethod(bank_id);
                                                    } else {
                                                        setSelectedMethod(id);
                                                    }
                                                    collapseOneOpen(true);
                                                }}>Eliminar</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Or value={false} cond={!!error}>
                        <Message value={false} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                            No hay bancos para mostrar.
                        </Message>
                        <Alert value={true} color="danger" className="mb-0">
                            Esta página no está disponible
                        </Alert>
                    </Or>
                </PreloadState>
            </CardBody>
            {isIterableArray(data) &&
                <CardFooter className="border-top">
                    <FullPagination
                        nextPage={nextPage}
                        prevPage={previousPage}
                        goToPage={goToPage}
                        meta={meta}
                        className={'shadow-none'}
                        posText={"métodos de pago"}
                        perPage={perPage} />
                </CardFooter>}
        </Card>
        <PayMethodAddModal isOpen={isOpen} setIsOpen={setIsOpen} method={selected} setSelected={setSelected} mutate={mutate} />
        {handleModalConfirm()}
    </>
}

export default PayMethods;